import React, { createContext, useContext, useState } from 'react';
import { getLocalStorage, removeLocalStorage, setLocalStorage } from '../../Helper/helperFunctions';
import { useDispatch } from 'react-redux';
import { clearUser, setUser } from '../../slices/authSlice';
import store from '../../store';
import { setCurrentRoute } from '../../slices/sidebarSlice';
import { setSelectedCustomer } from '../../slices/customersSlice';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const userRedux = store.getState().auth.user;
  const [user, setUserState] = useState(JSON.parse(getLocalStorage("user")) || null);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return userRedux?.accessToken !== undefined;
  });

  const login = (userId, role, accessToken, refreshToken, tenantId) => {
    const userData = {
      userId: userId,
      accessToken: accessToken,
      refreshToken: refreshToken,
      tenantId: tenantId,
      role: role,
    }
    dispatch(setUser(userData));
    setUserState(userData);
    dispatch(setCurrentRoute("home"));
    dispatch(setSelectedCustomer(tenantId))
    setLocalStorage("user", JSON.stringify(userData));
    setIsAuthenticated(true);
  };

  const logout = () => {
    dispatch(clearUser());
    setUserState(null);
    setIsAuthenticated(false);
    dispatch(setCurrentRoute("login"));
    removeLocalStorage("user");
  };

  const getAccessToken = () => {
    return userRedux?.accessToken
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, getAccessToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
